import styled from "@emotion/styled";
import { black } from "../color";
import { CustomFlex } from "./Layout.elements";
import { Children } from "react";
import InputBlock from "./InputBlock";

const { blackPearl } = black;

const Custom = styled(CustomFlex)`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const CustomInput = styled(InputBlock)`
  margin-top: auto;
`;

const BlackScreen = ({
  children,
  onQueryChanged,
  setBlackScreen,
  setQueryIndex,
  setPageNumber,
  setDynamicCodeSection,
  justifyContent
}) => {

  const Container = styled(CustomFlex)((props) => ({
    background: `${blackPearl}`,
    color: 'white',
    flex: '1',
    height: '100vh',
    width: '100%',
    '@media (max-width: 768px)': {
      position: 'relative',
    },
    '@media (min-width: 769px)': {
      justifyContent: `${props.justifyContent || 'flex-start'}`,
    }
  }))

  const handleQuestionChange = (val) => {
    onQueryChanged(val);
  };

  return (
    <>
    <Custom>
      <Container justifyContent={justifyContent} direction="column" align="none">
        {Children.map(children, (child) => (
          <>{child}</>
        ))}
      </Container>
      <CustomInput
        onQuestionChange={handleQuestionChange}
        setBlackScreen={setBlackScreen}
        setQueryIndex={setQueryIndex}
        setPageNumber={setPageNumber}
        setDynamicCodeSection={setDynamicCodeSection}
      />
    </Custom>
    </>
  );
};
export default BlackScreen;
